import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../styles/payrole-system/payrole-table.css";
import {
  fetchDraftPayrollData,
  fetchEmployeePayrollData,
} from "../../../redux/payrole-reducers/payroleSlice";
import { ReloadIcon } from "../../../images/icons/icons";
import NewPayroleProcess from "../payrole-process/NewPayroleProcess";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";
import CmnFilters from "../../lead-management/common/CmnFilters";
import PayroleTable from "../payrole-process/PayroleTable";
import { firstDateOfCurrentYearMonth } from "../../common-data/Converts";

const EmployeePayrollTable = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const { employeePayrollLoading } = useSelector((state) => state.payrole);
  const { loading } = useSelector((state) => state.dropdown);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const [activeTab, setActiveTab] = useState("processing-payroll");

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    accountType: "",
    selectedMonth: "",
    selectedUserApprovalStatus: "",
    selectedStakeholderApprovalStatus: "",
    selectedEmailStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: isStaff ? userInfoData?.user_id || userInfoData?.uid || "" : "",
    gym_id: allFilters.selectedGym?.value || "",
    account_type: allFilters.accountType?.value || "",
    month: allFilters.selectedMonth?.value || "",
    user_approval: allFilters.selectedUserApprovalStatus?.value || "",
    stack_holder_approval:
      allFilters.selectedStakeholderApprovalStatus?.value || "",
    email_sent: allFilters.selectedEmailStatus?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const getEmployeesData = () => {
    const filtertypeQP = "user_types=trainer,receptionist";
    const gymQP = filters?.gym_id ? `gym_id=${filters.gym_id}` : "";
    const accountTypeQP = filters?.account_type
      ? `account_type=${filters.account_type}`
      : "";
    const monthQP = filters?.month
      ? `payrole_month=${firstDateOfCurrentYearMonth(filters.month)}`
      : "";
    const searchQP = filters?.search ? `search=${filters.search}` : "";
    const finalQP = `${filtertypeQP}&${gymQP}&${accountTypeQP}${monthQP}&${searchQP}`;

    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: finalQP,
        pageNo: 1,
        limit: 5000,
      })
    );
  };

  const getEmployeePayrollData = (filters) => {
    dispatch(
      fetchEmployeePayrollData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getDraftPayrollData = (filters) => {
    const { user_approval, stack_holder_approval, ...rest } = filters;

    dispatch(
      fetchDraftPayrollData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  };

  const getConditionalReload = () => {
    if (activeTab === "processing-payroll" || !isAdmin) {
      getEmployeePayrollData(filters);
    } else if (activeTab === "draft-payroll") {
      getDraftPayrollData(filters);
    } else {
      getEmployeesData();
    }
  };

  useEffect(() => {
    // if (activeTab === "processing-payroll") {
    //   getEmployeePayrollData(filters);
    // }
    getConditionalReload();
  }, [filters, activeTab]);

  useEffect(() => {
    if (activeTab === "new-payroll") {
      getEmployeesData();
    }
  }, [
    activeTab,
    filters.gym_id,
    filters.account_type,
    filters?.month,
    filters.search,
  ]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isClusterManager && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      account_type: allFilters.accountType?.value || "",
      month: allFilters.selectedMonth?.value || "",
      user_approval: allFilters.selectedUserApprovalStatus?.value || "",
      stack_holder_approval:
        allFilters.selectedStakeholderApprovalStatus?.value || "",
      email_sent: allFilters.selectedEmailStatus?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.accountType,
    allFilters.selectedMonth,
    allFilters.selectedUserApprovalStatus,
    allFilters.selectedStakeholderApprovalStatus,
    allFilters.selectedEmailStatus,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <div className="pp-employee-payroll-table-container">
      <div className="pp-bulk-header">
        <div className="pp-employee-payroll-card-header">
          <span>Employee Payroll Management</span>
          <button variant="dark" type="button" onClick={getConditionalReload}>
            <ReloadIcon />
          </button>
        </div>
      </div>

      {isAdmin && (
        <div className="pp-tab-toggle mt30 mb30">
          <button
            className={`pp-tab-toggle-btn ${
              activeTab === "processing-payroll"
                ? "pp-tab-toggle-active"
                : "pp-tab-toggle-inactive"
            }`}
            onClick={() => handleTabChange("processing-payroll")}
          >
            Processing Payroll
          </button>
          <button
            className={`pp-tab-toggle-btn ${
              activeTab === "draft-payroll"
                ? "pp-tab-toggle-active"
                : "pp-tab-toggle-inactive"
            }`}
            onClick={() => handleTabChange("draft-payroll")}
          >
            Draft Payroll
          </button>
          <button
            className={`pp-tab-toggle-btn ${
              activeTab === "new-payroll"
                ? "pp-tab-toggle-active"
                : "pp-tab-toggle-inactive"
            }`}
            onClick={() => handleTabChange("new-payroll")}
          >
            Add New Payroll
          </button>
        </div>
      )}

      <CmnFilters
        from={"payrole-processor-logs"}
        clickedCard={
          activeTab === "new-payroll"
            ? "inhouse-users"
            : activeTab === "draft-payroll"
            ? "draft-payroll"
            : "payrole-processor-logs"
        }
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        searchPlaceHolder="Search by staff name, mobile, email..."
        isLoading={loading || employeePayrollLoading}
      />

      {(activeTab === "processing-payroll" ||
        !isAdmin ||
        activeTab === "draft-payroll") && (
        <PayroleTable
          userInfoData={userInfoData}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          callFunction={getConditionalReload}
          isDraft={activeTab === "draft-payroll"}
        />
      )}

      {activeTab === "new-payroll" && (
        <NewPayroleProcess
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          userInfoData={userInfoData}
        />
      )}
    </div>
  );
};

export default EmployeePayrollTable;